import React from 'react';
import useVisibility from '../../../../../../shared/utils/hooks/useVisibility';

import BottomBanner from './components/BottomBanner';
import LoadingBlock from './components/LoadingBlock';
import ExpertBlock from './components/ExpertBlock';

const ExpertMeeting = ({ sale }) => {
  const [expertContactIsVisible, expertContactRef] = useVisibility({
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });

  const allocatedExpert = sale.state === 'awaiting_apointment' ? null : sale.expert;

  return (
    <div className='h-fit flex flex-col justify-center items-center border border-ih-blue px-3 py-8 md:px-8 rounded-3xl bg-hosman-gradient-1 text-center relative' data-testid='ExpertMeeting'>
      <div className={`transition-opacity duration-700 ${!allocatedExpert ? 'opacity-100 relative' : 'opacity-0 absolute'}`} data-testid='LoadingBlockContainer'>
        <LoadingBlock />
      </div>

      <div className={`transition-opacity duration-700 ${allocatedExpert ? 'opacity-100 relative' : 'opacity-0 absolute pointer-events-none'}`} data-testid='ExpertBlockContainer'>
        <ExpertBlock expert={allocatedExpert} expertContactRef={expertContactRef} />
      </div>

      {allocatedExpert &&
        <BottomBanner open={!expertContactIsVisible} expert={allocatedExpert} />
      }
    </div>
  );
}

export default ExpertMeeting;
